interface FooterProps {
  // compact mode — used on auth/connect full-page screens
  compact?: boolean;
}

export function Footer({ compact }: FooterProps) {
  if (compact) {
    return (
      <footer className="text-xs text-muted-foreground text-center">
        <span>Bubble WU Auditor</span>
        <span className="mx-2 opacity-40">·</span>
        <a
          href="/privacy"
          className="hover:text-muted-foreground transition-colors"
        >
          Privacy
        </a>
        <span className="mx-2 opacity-40">·</span>
        <a
          href="/terms"
          className="hover:text-muted-foreground transition-colors"
        >
          Terms
        </a>
      </footer>
    );
  }

  return (
    <footer
      className="mt-12 border-t pt-5 pb-2"
      style={{ borderColor: "hsl(220 18% 85% / 0.08)" }}
    >
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 text-xs text-muted-foreground">
        <span>Bubble WU Auditor — AV Agency</span>
        <div className="flex items-center gap-4">
          <a
            href="/privacy"
            className="hover:text-muted-foreground transition-colors"
          >
            Privacy
          </a>
          <a
            href="/terms"
            className="hover:text-muted-foreground transition-colors"
          >
            Terms
          </a>
        </div>
      </div>
    </footer>
  );
}
